import axios from "axios";
import { UPDATE_COMMENT_COUNT } from "./types";
import { COMMENTS_ENDPOINT, COMMENTS_PUBLIC_ENDPOINT } from "./endpoints";

export const fetchComments = (objects, contentType) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${COMMENTS_ENDPOINT}?object_pk=${objects}&content_type=${contentType}`
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => reject(error));
  });
};

export const updateCommentCount = (payload) => (dispatch) => {
  dispatch({
    type: UPDATE_COMMENT_COUNT,
    payload: payload,
  });
};

export const addComment = (data, signalToken) => {
  return new Promise((resolve, reject) => {
    axios
      .post(COMMENTS_ENDPOINT, data, {
        cancelToken: signalToken,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => reject(error));
  });
};

export const addCommentPublic = (data, signalToken) => {
  return new Promise((resolve, reject) => {
    axios
      .post(COMMENTS_PUBLIC_ENDPOINT, data, {
        cancelToken: signalToken,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => reject(error));
  });
};
